import React, { memo } from 'react'
import { Avatar } from '@mui/material'

const ProviderIcon = ({
  src,
  icon,
  size = 64,
  sx,
  noBorder = false,
  variant = ''
}) => {
  return (
    <Avatar
      sx={{
        width: size,
        height: size,
        // mx: 'auto',
        ...(!noBorder && {
          border:
            '1px solid rgba(var(--palette-common-onBackgroundChannel) / 0.23)'
        }),
        ...sx
      }}
      slotProps={{
        img: {
          loading: 'lazy'
        }
      }}
      src={src}
      variant={variant}
    >
      {icon && icon}
    </Avatar>
  )
}

export default memo(ProviderIcon)
